import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
  Typography,
} from '@mui/material';
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import ImageIcon from "@mui/icons-material/Image";
import DescriptionIcon from "@mui/icons-material/Description";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import DownloadIcon from "@mui/icons-material/Download";
import Box from '@mui/material/Box';
import {SupportTicketAttachmentModel} from '../../../../model/support/support-ticket-attachment.model';

type Props = {
  attachments: SupportTicketAttachmentModel[];
};

function getFileIcon(contentType: string) {
  if (contentType.includes("pdf")) return <PictureAsPdfIcon color="error" />;
  if (contentType.startsWith("image/")) return <ImageIcon color="primary" />;
  if (
    contentType.includes("word") ||
    contentType.includes("officedocument.wordprocessingml")
  )
    return <DescriptionIcon color="action" />;
  return <InsertDriveFileIcon />; // fallback
}

export const SupportTicketAttachmentList = ({ attachments }: Props)=> {
  const handleOpen = (url: string) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  if (!attachments || attachments.length === 0) {
    return (
      <Box
        p={2}
        display="flex"
        justifyContent="center"
        alignItems="center"
        color="text.secondary"
      >
        <Typography variant="body2">Brak załączników</Typography>
      </Box>
    );
  }

  return (
    <List dense>
      {attachments.map((file) => (
        <ListItem
          key={file.id}
          divider
          secondaryAction={
            <IconButton
              edge="end"
              aria-label="download"
              onClick={() => handleOpen(file.url)}
            >
              <DownloadIcon />
            </IconButton>
          }
        >
          <ListItemIcon>{getFileIcon(file.contentType)}</ListItemIcon>
          <ListItemText primary={file.fileName} />
        </ListItem>
      ))}
    </List>
  );
}
